import { ChangeEvent } from "react";
import { resources } from "@constants/hardcoded-strings";
import { TextareaFormGroup } from "@containers/common/textarea-form-group/textarea-form-group";
import { ThemingFormSection } from "@containers/common/theming-form-section/theming-form-section";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { FormattedMessageTemplate } from "@idw-types/data/message-template";
import commonStyles from "../../message-template-details-component.less";
import styles from "./message-template-content-form-section.less";
import { MessageTemplateContentValidationErrors } from "@idw-types/common/validation/message-template/message-template-validation-errors";

type MessageTemplateContentFormSectionProps = {
    state: FormattedMessageTemplate;
    isDisabled: boolean;
    labelWidth: LabelWidthTypes;
    validationErrors: MessageTemplateContentValidationErrors;
    handleUpdateTemplate: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const MessageTemplateContentFormSection = (props: MessageTemplateContentFormSectionProps) => {
    const {
        state,
        isDisabled,
        labelWidth,
        validationErrors,      
        handleUpdateTemplate
    } = props;

    const resource = resources.pages.messageTemplateDetails.tabs.content;
    return (
        <ThemingFormSection title={resource.sections.template.title}>
            <div className={commonStyles.sectionDescription}>{resource.sections.template.description}</div>
            <TextareaFormGroup
                className={styles.expandedTextArea}
                controlId="message-template-template-input"
                automationId="message-template-template-input"
                label={resource.inputs.template.label}
                ariaLabel={resource.inputs.template.label}
                placeholder={resource.inputs.template.placeholder}
                value={state.template}
                onChange={handleUpdateTemplate}
                disabled={isDisabled}
                isRequired={true}
                labelWidth={labelWidth}
                layout={LayoutTypes.COLUMN}
            />
            {validationErrors?.requiredVariableError}
        </ThemingFormSection>
    );
}